module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-color__c-checkerboard",
    style: ({
      background: _vm.bgStyle
    })
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c4f860f0!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-color/src/components/common/Checkboard.vue
// module id = 354
// module chunks = 1